export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    cancelIcon: {
      type: String,
      default: 'x'
    },
    cancelTxt: {
      type: String
    },
    confirmTxt: {
      type: String
    },
    swipeTime: {
      type: Number,
      default: 2500
    },
    maskClosable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    _cancelTxt () {
      return this.cancelTxt || this.gettext('取消')
    },
    _confirmTxt () {
      return this.confirmTxt || this.gettext('确定')
    }
  }
}
